import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  adminProducts: [],
  loading: false,
  error: null,
  success: false,
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    // **************************************PRODUCT MANAGEMENT BY VENDOR*********************************

    // Get all products
    getProductsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getProductsSuccess(state, action) {
      state.loading = false;
      state.products = action.payload;
      state.success = true;
    },
    getProductsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Create product
    createProductStart(state) {
      state.loading = true;
      state.error = null;
    },
    createProductSuccess(state, action) {
      state.loading = false;
      state.products.unshift(action.payload);
      state.success = true;
    },
    createProductFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Update product
    updateProductStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateProductSuccess(state, action) {
      state.loading = false;
      state.products = state.products.map((product) =>
        product._id === action.payload._id ? action.payload : product
      );
      state.success = true;
    },
    updateProductFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Get inventory by vendor
    getInventoryStart(state) {
      state.loading = true;
      state.error = null;
    },
    getInventorySuccess(state, action) {
      state.loading = false;
      state.products = action.payload;
      state.success = true;
    },
    getInventoryFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Update product stock
    updateStockStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateStockSuccess(state, action) {
      state.loading = false;
      state.products = state.products.map((product) =>
        product._id === action.payload._id ? action.payload : product
      );
      state.success = true;
    },
    updateStockFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // **************************************PRODUCT MANAGEMENT BY ADMIN*********************************
    // Get all products
    getProductsByAdminStart(state) {
      state.loading = true;
      state.error = null;
    },
    getProductsByAdminSuccess(state, action) {
      state.loading = false;
      state.products = action.payload;
      state.success = true;
    },
    getProductsByAdminFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Create product
    createProductByAdminStart(state) {
      state.loading = true;
      state.error = null;
    },
    createProductByAdminSuccess(state, action) {
      state.loading = false;
      state.products.unshift(action.payload);
      state.success = true;
    },
    createProductByAdminFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Update product
    updateProductByAdminStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateProductByAdminSuccess(state, action) {
      state.loading = false;
      state.products = state.products.map((product) =>
        product._id === action.payload._id ? action.payload : product
      );
      state.success = true;
    },
    updateProductByAdminFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // review product approval
    updateProductApprovalStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateProductApprovalSuccess(state, action) {
      state.loading = false;
      state.adminProducts = state.adminProducts.map((adminProduct) =>
        adminProduct._id === action.payload._id ? action.payload : adminProduct
      );
      state.success = true;
    },
    updateProductApprovalFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Reset state
    resetProductState(state) {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  getProductsStart,
  getProductsSuccess,
  getProductsFailure,
  createProductStart,
  createProductSuccess,
  createProductFailure,
  updateProductStart,
  updateProductSuccess,
  updateProductFailure,
  getInventoryStart,
  getInventorySuccess,
  getInventoryFailure,
  updateStockStart,
  updateStockSuccess,
  updateStockFailure,

  //By Admin
  getProductsByAdminStart,
  getProductsByAdminSuccess,
  getProductsByAdminFailure,
  createProductByAdminStart,
  createProductByAdminSuccess,
  createProductByAdminFailure,
  updateProductByAdminStart,
  updateProductByAdminSuccess,
  updateProductByAdminFailure,
  updateProductApprovalStart,
  updateProductApprovalSuccess,
  updateProductApprovalFailure,
  

  resetProductState,
} = productSlice.actions;

export default productSlice.reducer;
